import clsx from "clsx";
import { bool, element, func, node, string } from "prop-types";
import { useState } from "react";

import classes from "./EmptyState.module.scss";

const EmptyState = ({
  icon,
  title,
  description = "",
  className,
  enableDropzone,
  buttons,
  bordered = false,
  onDrop,
}) => {
  const [isOver, setIsOver] = useState(false);

  const onDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOver(true);
  };

  const onDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOver(false);
  };

  const onDropFiles = (e) => {
    e.preventDefault();
    setIsOver(false);

    if (enableDropzone && onDrop) {
      onDrop(e);
    }
  };

  return (
    <div
      className={clsx(classes.emptyState, className, {
        [classes["emptyState--has_dropzone"]]: enableDropzone,
        [classes["emptyState--has_dropzone--active"]]: enableDropzone && isOver,
        [classes.bordered]: bordered,
      })}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={enableDropzone ? onDropFiles : undefined}
    >
      {icon && <div className={classes.iconContainer}>{icon}</div>}
      <h3 className={classes.title}>{title}</h3>
      <p className={classes.description}>{description}</p>
      {Boolean(buttons) && <div className={classes.buttons}>{buttons}</div>}
    </div>
  );
};

EmptyState.propTypes = {
  title: string.isRequired,
  buttons: node,
  className: string,
  icon: element,
  description: string,
  enableDropzone: bool,
  bordered: bool,
  onDrop: func,
};

export default EmptyState;
